export default __webpack_public_path__ + "static/media/hbs-k-bpk-3.1ccc6204.png";